<template>
  <fo-layout>
    <div class="contact-center" v-if="loading">
      <!-- 暂时用官网地图，logo字段未添加 -->
      <div class="backimg centerimage primary-bg">
        <div class="contact-bar">
          <h1 class="primary title pb-10 to-1">
            <span class="dis-bl ht-40 gray-bg"></span>
          </h1>
          <p class="primary title-alt">
            <span class="dis-bl ht-18 gray-bg mb-10"></span>
            <span class="dis-bl ht-18 gray-bg"></span>
          </p>
        </div>
      </div>
    </div>
    <div class="contact-center" v-else>
      <div>
        <!-- 暂时用官网地图，logo字段未添加 -->
        <div :style="'background-image: url(' + contact.big_img + ');'" class="backimg centerimage">
          <div class="contact-bar">
            <h1 class="primary title pb-10 to-1">{{contact.title}}</h1>
            <p class="primary title-alt">{{contact.infoa}}</p>
          </div>
        </div>
      </div>
      <a-row :gutter='30' class="contacttop">
        <a-col :sm="8" v-for="(item, i) of contactData" :key="i">
          <div class="ta-l bb">
            <img :src="item.contact_icon" width="90px" class="ht-50 pr lf--25" alt="">
            <p class="pt-10 font-weight">{{item.contact_title}}</p>
          </div>
          <div class="pt-20">
            <p class="mb-0" v-for="(data, ind) in item.contact_message.split(',')" :key="ind">{{data}}</p>
          </div>
        </a-col>
      </a-row>
    </div>
  </fo-layout>
</template>
<script type="text/javascript">
import { mapGetters } from 'vuex'
export default {
  computed: mapGetters([
    'commonData'
  ]),
  data () {
    return {
      loading: true,
      contact: {
        title: '',
        infoa: '',
        big_img: ''
      },
      contactData: []
    }
  },
  watch: {
    'commonData.web_comp_contact' (obj) {
      this.contact = JSON.parse(obj.value)
      this.loading = false
    },
    'commonData.web_contact' (obj) {
      this.contactData = JSON.parse(obj.value)
      this.loading = false
    }
  },
  mounted () {
    if (this.commonData.web_comp_intro.value) {
      this.contact = JSON.parse(this.commonData.web_comp_contact.value)
      this.contactData = JSON.parse(this.commonData.web_contact.value)
      this.loading = false
    }
  }
}
</script>
<style lang="less">
/* 小于等于 750 */
@media screen and (max-width: 751px) and (min-width: 300px) {
.contact-center {
  .contacttop {
    margin-top: -20px;
    .bb {
      margin-top: 20px;
    }
  }
  .backimg {
    width: 100%;
    padding: 0;
    height: 260px;
    position: relative;
    margin-bottom: 140px;
  }
  .contact-bar {
    width: 100%;
    font-family: Georgia, 宋体;
    position: absolute;
    top: 270px;
    .title-alt {
      font-size: 14px;
      margin: 0;
    }
    .title {
      font-size: 28px;
      font-weight: bold;
      margin: 0;
    }
  }
  .font-weight {
    font-weight:bolder;
    font-size: 16px;
  }
}
}
/* 大于 750 */
@media screen and (min-width: 751px) {
.contact-center {
  .backimg {
    padding-top: 100px;
    height: 400px;
    padding-left: 30px;
    margin-bottom: 40px;
  }
  .contact-bar {
    width: 34%;
    font-family: Georgia, 宋体;
    .title-alt {
      font-size: 16px;
      font-weight: bold;
      margin: 0;
    }
    .title {
      font-size: 3em;
      font-weight: bold;
      margin: 0;
    }
  }
  .font-weight {
    font-weight:bolder;
    font-size: 16px;
  }
}
}
</style>



// WEBPACK FOOTER //
// src/pages/Models/contact.vue